module.exports = __webpack_public_path__ + "static/arthur_rees-cd3b78a22c4d565f2b08055418c9f8b6.png";